export default __webpack_public_path__ + "3f9f9be5229eea543a57a041b9938424.svg";